var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionButton',_vm._b({on:{"click":_vm.onClick}},'ActionButton',_vm.$props,false),[_c('PlusIcon'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }